export default "__VITE_ASSET__CbiWhXyv__"